'use client';

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel';
import { FanficCard } from '@/features/fanfic-card/components/fanfic-card';
import { cn } from '@/lib/utils';
import { transformFanficData } from '@/features/fanfic-page/utils';

export interface SimilarFanfic {
  id: number | string;
  title: string;
  authors?: Array<{ id: number | string; name: string }>;
  heroImage?: { url: string };
  rating?: string;
  focus?: 'het' | 'gen';
  readersCount?: number;
  totalWordCount?: number;
  createdAt?: string;
  publishedAt?: string;
  characters?: any[];
  pairings?: any[];
  tags?: any[];
  fandom?: any;
}

export interface SimilarFanficsSectionProps {
  relatedFanfics: SimilarFanfic[];
  activeTab: 'description' | 'chapters' | 'reviews';
}

/**
 * SimilarFanficsSection - renders a carousel of similar fanfics.
 * Server component that receives pre-fetched data.
 */
export function SimilarFanficsSection({ relatedFanfics, activeTab }: SimilarFanficsSectionProps) {
  // Empty state: don't render section if no fanfics
  if (!relatedFanfics || relatedFanfics.length === 0) {
    return null;
  }

  const transformedRelatedFanfics = relatedFanfics.slice(0, 10).map(transformFanficData);

  return (
    <div
      className={cn(
        'min-[1000px]:px-[10px] px-2 pb-4 max-w-[1380px] mx-auto mt-auto',
        activeTab === 'chapters' && 'min-[1000px]:pt-[140px]',
      )}
    >
      <Carousel opts={{ dragFree: true }}>
        <div className="pl-4 py-4 rounded-2xl bg-[#F2F3F7] grid relative">
          <p className="text-2xl uppercase font-black leading-[0.9] text-[#111827] mb-3">Похожее</p>

          <CarouselContent className="min-[1000px]:h-[567px]">
            {transformedRelatedFanfics.map((fanfic) => (
              <CarouselItem key={fanfic.id} className="basis-[210px] pl-0 ml-5 last:mr-5">
                <FanficCard
                  {...fanfic}
                  characters={fanfic.characters}
                  pairings={fanfic.pairings}
                  variant="similar"
                  tags={fanfic.tags?.map((tag: any) => tag.title)}
                  fandom={fanfic.fandom}
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="grid grid-cols-2 gap-2 absolute right-4 top-2">
            <CarouselPrevious />
            <CarouselNext />
          </div>
        </div>
      </Carousel>
    </div>
  );
}
